import { CalendarOutlined, DeleteOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { Button, Card, Divider, Modal, Spin, Typography } from 'antd';
import React, { useState } from 'react';

interface ViewWorkOrdersProps {
  close: () => void;
  createWorkOrder: () => void;
  isEmergency: boolean;
}
const ViewWorkOrders: React.FC<ViewWorkOrdersProps> = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [workOrders, setWorkOrders] = useState([]);
  const [deleteConfirmationVisible, setDeleteConfirmationVisible] = useState(false);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState<number | null>(null);

  const deleteWorkOrder = (id: number | null) => {};

  return (
    <div className="position-absolute d-flex flex-column gap-2 overflow-auto" style={{ top: '16px', left: '16px', bottom: '16px', width: '400px' }}>
      <Card id="rf-simulation-view-card">
        <div className="d-flex flex-row justify-content-between align-items-center">
          <Typography.Title level={5}>Work Orders</Typography.Title>
          <Button
            type="link"
            color="danger"
            style={{ color: 'red' }}
            onClick={() => {
              props.close();
            }}>
            Cancel
          </Button>
        </div>
        <Divider />
        <Button
          type="primary"
          className="w-100"
          onClick={() => {
            props.createWorkOrder();
          }}>
          Create New Work Order
        </Button>

        {isLoading && (
          <div className="d-flex justify-content-center align-items-center py-4">
            <Spin spinning={isLoading} />
          </div>
        )}

        <div className="d-flex flex-column gap-2 overflow-auto p-2">
          {workOrders.map((workOrder: any) => (
            <>
              <Card
                title={
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <Typography.Title level={5}>{workOrder.name}</Typography.Title>
                    <div className="d-flex flex-row gap-1">
                      <Button
                        type="link"
                        color="danger"
                        size="small"
                        onClick={() => {
                          setDeleteConfirmationVisible(true);
                          setDeleteConfirmationId(workOrder.id);
                        }}>
                        <DeleteOutlined style={{ color: 'red' }} />
                      </Button>
                    </div>
                  </div>
                }
                key={workOrder.id}
                className="d-flex flex-column gap-2 mt-3">
                <div className="d-flex flex-column gap-1">
                  <div className="d-flex flex-row gap-1">
                    <CalendarOutlined />
                    <Typography.Text strong>Created On : </Typography.Text>
                    <Typography.Text type="secondary">{new Date(workOrder.created_at).toUTCString()}</Typography.Text>
                  </div>

                  <div className="d-flex flex-row gap-1">
                    <EnvironmentOutlined />
                    <Typography.Text strong>Location : </Typography.Text>
                    <Typography.Text type="secondary">{`${workOrder.location.latitude.toFixed(6)}, ${workOrder.location.longitude.toFixed(
                      6
                    )}`}</Typography.Text>
                  </div>
                </div>
              </Card>
            </>
          ))}
        </div>
      </Card>
      <Modal
        open={deleteConfirmationVisible}
        title="Delete Work Order"
        okText="Delete"
        cancelText="Cancel"
        onCancel={() => setDeleteConfirmationVisible(false)}
        onOk={() => deleteWorkOrder(deleteConfirmationId ?? null)}>
        <Typography.Text>Are you sure you want to delete the work order?</Typography.Text>
      </Modal>
    </div>
  );
};

export default ViewWorkOrders;
